(function () {
  function getCard(node) {
    return node && node.closest('.product-card, .ff-store-card');
  }

  function getPrimaryImage(card) {
    return card && card.querySelector('.product-card__media a.media > img, .ff-store-card__media img');
  }

  function rememberOriginalImage(image) {
    if (!image || image.dataset.ffOriginalSrc) return;

    image.dataset.ffOriginalSrc = image.currentSrc || image.getAttribute('src') || '';
    image.dataset.ffOriginalSrcset = image.getAttribute('srcset') || '';
    image.dataset.ffOriginalSizes = image.getAttribute('sizes') || '';
  }

  function setCardImage(swatch) {
    var card = getCard(swatch);
    var image = getPrimaryImage(card);
    var src = swatch.dataset.cardImageSrc;

    if (!image || !src) return;

    rememberOriginalImage(image);
    image.setAttribute('src', src);

    if (swatch.dataset.cardImageSrcset) {
      image.setAttribute('srcset', swatch.dataset.cardImageSrcset);
    }
  }

  function restoreCardImage(card) {
    if (!card || !card.classList) return;
    if (!card.classList.contains('product-card') && !card.classList.contains('ff-store-card')) return;
    var image = getPrimaryImage(card);
    if (!image || !image.dataset.ffOriginalSrc) return;

    image.setAttribute('src', image.dataset.ffOriginalSrc);

    if (image.dataset.ffOriginalSrcset) {
      image.setAttribute('srcset', image.dataset.ffOriginalSrcset);
    } else {
      image.removeAttribute('srcset');
    }

    if (image.dataset.ffOriginalSizes) {
      image.setAttribute('sizes', image.dataset.ffOriginalSizes);
    } else {
      image.removeAttribute('sizes');
    }
  }

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest('.product-card .color-swatch[data-card-image-src], .ff-store-card .color-swatch[data-card-image-src]');
    if (swatch) setCardImage(swatch);
  });

  document.addEventListener('focusin', function (event) {
    var swatch = event.target.closest('.product-card .color-swatch[data-card-image-src], .ff-store-card .color-swatch[data-card-image-src]');
    if (swatch) setCardImage(swatch);
  });

  document.addEventListener('mouseleave', function (event) {
    restoreCardImage(event.target);
  }, true);
})();
